import React from 'react'
import Popup from '../../common/Popup/Popup'
import TaskTable from './TaskTable'
import { setActionItemId, setCopiedAndRedirect } from '../../redux/taskSlice'
import { useDispatch, useSelector } from 'react-redux'
import AttentionPopup from './Popups/AttentionPopup'
const TaskPopup = ({closeModal, useTableInAuditTrail = false, auditTrailRow}) => {
  const copiedAndRedirecred = useSelector(state=>state.task.copiedAndRedirecred);
  const dispatch = useDispatch();
  return <>
    <Popup closeModal={()=>{
      closeModal(false);
      dispatch(setActionItemId(null));
    }}
    title="Task Table"> 
        <TaskTable 
          closePopup={closeModal}
          useTableInAuditTrail={useTableInAuditTrail}
          auditTrailRow={auditTrailRow}
        />
    </Popup>
    {copiedAndRedirecred && (
      <AttentionPopup closeModal={() => {
        dispatch(setCopiedAndRedirect(false));
      }}>
        <p className="tasks-copied-message">Tasks have been copied. Please review them in the Task Table.</p>
      </AttentionPopup>
    )}
  </>
}

export default TaskPopup